/**
 * KCIS Edition display helper.
 *
 * Phase 6A: maps the practitioner's `subscription_tier` (returned by
 * /api/auth/admin/login) to a user-facing edition label. RENDER-ONLY.
 *
 * - Backend `admins.subscription_tier` remains the single source of truth.
 * - This module does NOT enforce permissions — RBAC stays in
 *   /app/backend/auth.py via require_admin / require_super_admin / require_pro_tier.
 *
 * Reserved tiers (`clinical_edition`, `enterprise_edition`) are wired so the
 * display automatically picks them up the moment those strings are written into
 * the admin doc — no further frontend changes needed.
 */

export const PRODUCT_NAME = "KISSED Clinic OS";

/**
 * @param {string|null|undefined} tier — value from admins.subscription_tier
 * @returns {string|null} display label like "Lite Edition", or null when no
 *                        edition line should be shown (super_admin, signed out, public)
 */
export function editionFor(tier) {
  switch (tier) {
    case "practitioner_lite":   return "Lite Edition";
    case "practitioner_pro":    return "Pro Edition";
    case "clinical_edition":    return "Clinical Edition";
    case "enterprise_edition":  return "Enterprise Edition";
    default:                    return null;
  }
}
